export const normalizeIdentity = (identity: string, seperator = '+') => {
  const _identity = identity.split(seperator);
  _identity.pop();
  return _identity.join(seperator);
};
